<div class="liq-card">
  <div class="liq-card-icon" aria-hidden="true">
    <svg *ngIf="icon === 'readability'"
         viewBox="0 0 24 24" fill="none" stroke="currentColor"
         stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
      <path d="M3 18 L7 6 L11 18 M4.5 14 L9.5 14"></path>
      <path d="M21 11 a3 3 0 0 1 -6 0 a3 3 0 0 1 6 0 M21 11 V18"></path>
    </svg>
    <svg *ngIf="icon === 'scarcity'"
         viewBox="0 0 24 24" fill="none" stroke="currentColor"
         stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
      <rect x="3" y="14" width="3.5" height="7"></rect>
      <rect x="9" y="9" width="3.5" height="12"></rect>
      <rect x="15" y="4" width="3.5" height="17"></rect>
    </svg>
    <svg *ngIf="icon === 'substitutes'"
         viewBox="0 0 24 24" fill="none" stroke="currentColor"
         stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
      <circle cx="9" cy="10" r="5"></circle>
      <circle cx="15" cy="14" r="5"></circle>
    </svg>
  </div>
  <div class="liq-card-body">
    <div class="liq-card-title">{{ title }}</div>
    <div class="liq-card-detail">{{ body }}</div>
  </div>
</div>
